import { connectDocument } from './DocumentButton.connect.legacy';
import { RawDocumentButton } from './DocumentButton.legacy';

export const LegacyDocumentButton = connectDocument(RawDocumentButton);
